import { colors, fade, createMuiTheme } from "housecall-ui"
import { greenA400, white } from "material-ui-deprecated/styles/colors"

const { blue, blueGrey, green, grey, pink } = colors;

const styles = {
  fontFamily: "Roboto, Lato, Arial, sans-serif",
  palette: {
    primary: {
      light: blue[100],
      main: blue[500],
      dark: blue[500],
      white: white
    },
    secondary: {
      light: green["A100"],
      main: green["A400"],
      contrastDefaultColor: "dark"
    },
    buttonBackgroundColor: grey[300],
    error: pink,
    blueGrey: {
      dark: "#00314a"
    },
    accent1Color: greenA400,
    primary1Color: blue[500],
    brandPrimaryLight: blueGrey[50],
    consumer: green,
    hover: fade(blue[500], 0.04),
    background: {
      default: white
    }
  },
  typography: {
    useNextVariants: true
  },
  overrides: {
    MuiTypography: {
      colorTextPrimary: {
        color: grey[900]
      },
      colorTextSecondary: {
        color: grey[700]
      },
      colorPrimary: {
        color: blue[500]
      },
      colorSecondary: {
        color: "white"
      },
      colorError: {
        color: pink[500]
      },
      h1: {
        fontSize: 24,
        fontWeight: 400,
        color: grey[900],
        lineHeight: "24px",
        fontFamily: "'Open Sans', Roboto, Lato, Arial, sans-serif"
      },
      h2: {
        fontSize: 20,
        fontWeight: 700,
        color: grey[900],
        lineHeight: "20px",
        fontFamily: "'Open Sans', Roboto, Lato, Arial, sans-serif"
      },
      h3: {
        fontSize: 34,
        fontWeight: 700,
        color: grey[900],
        lineHeight: "34px",
        fontFamily: "'Open Sans', Roboto, Lato, Arial, sans-serif"
      },
      h4: {
        fontSize: 56,
        fontWeight: 700,
        color: grey[900],
        lineHeight: "56px",
        fontFamily: "'Open Sans', Roboto, Lato, Arial, sans-serif"
      },
      h5: {
        fontSize: 28,
        fontWeight: 700,
        color: grey[900],
        lineHeight: "56px",
        fontFamily: "'Open Sans', Roboto, Lato, Arial, sans-serif"
      },
      subtitle1: {
        fontSize: 16,
        fontWeight: 700,
        color: grey[900],
        fontFamily: "'Open Sans', Roboto, Lato, Arial, sans-serif"
      },
      subtitle2: {
        fontSize: 14,
        fontWeight: 700,
        color: grey[700]
      },
      body1: {
        fontSize: 16,
        fontWeight: 400,
        color: grey[900]
      },
      body2: {
        fontSize: 14,
        fontWeight: 400,
        color: grey[900]
      },
      button: {
        fontSize: 14,
        fontWeight: 400,
        fontFamily: "'Open Sans', Roboto, Lato, Arial, sans-serif"
      },
      caption: {
        fontSize: 12,
        fontWeight: 400,
        color: grey[700]
      }
    },
    MuiAppBar: {
      colorDefault: {
        backgroundColor: "white"
      },
      colorPrimary: {
        backgroundColor: "#00314a"
      },
      colorSecondary: {
        backgroundColor: grey[100]
      }
    },
    MuiTableCell: {
      head: {
        fontSize: 14,
        fontWeight: 500,
        color: grey[700]
      },
      body: {
        fontSize: 14,
        fontWeight: 400,
        color: grey[900]
      }
    },
    MuiButton: {
      text: {
        fontFamily: "'Open Sans', Roboto, Lato, Arial, sans-serif"
      },
      textSecondary: {
        color: pink[500],
        backgroundColor: "white",
        "&:hover": {
          backgroundColor: pink[50]
        }
      }
    }
  },
  spacing: 1,
  icon: {
    grey: {
      color: grey[500]
    }
  }
}

export default createMuiTheme(styles)
